import './Blog.css';

const Blog = ({ closeApp }) => {

    const goBack = () => {
        window.history.back();
    };
    const goFwd = () => {
        window.history.forward();
    };

    return (
        <div className="Blog">
            <iframe src="https://chriscarey.com/blog/" className="iframe-placeholder"></iframe>
            Blog
            
            

            <div className="app-open-controls">
                <div className="app-open-control-item"><button onClick={goBack}>Back</button></div>
                <div className="app-open-control-item"><button onClick={goFwd}>Fwd</button></div>
                <div className="app-open-control-item"></div>
                <div className="app-open-control-item"><button onClick={closeApp}>Close</button></div>
            </div>
            
        </div>
    );
};
export default Blog;